<template>
  <div class="ei-type-writer"
       :style="{'--height':height+'px',
       '--fontSize':fontsize+'px',
       '--length':length,
       '--duration':length*speed+'s'}">
    {{ content }}
  </div>
</template>

<script>
export default {
  name: "EiTypeWriter",
  props: {
    height: {
      type: Number,
      default: 60
    },
    fontsize: {
      type: Number,
      default: 60
    },
    content: {
      type: String,
      required: true
    },
    speed:{
      type: Number,
      default: 0.2
    }
  },
  data() {
    return {
      length: 0
    }
  },
  created() {
    this.length = this.content.length
  },
  mounted() {
    document.styleSheets[document.styleSheets.length - 1].insertRule(`
            @keyframes typing{
                0%{width: 2ch;}
                100%{width: ${this.length * 2}ch;}
            }`)
  }
}
</script>

<style scoped lang="scss">
.ei-type-writer {
  margin: 0;
  padding: 0;
  font-size: var(--fontSize);
  width: 2ch;
  overflow: hidden;
  height: var(--height);
  line-height: var(--height);
  animation: var(--duration) typing ease forwards;
  animation-delay:0.5s;

  //animation: var(--duration) typing steps(var(--length), jump - none) forwards;
}

//@keyframes typing {
//  from {
//    width: 2ch;
//  }
//  to {
//    width: 8ch;
//  }
//}

</style>
